import React, { useEffect, useMemo, useRef, useState } from 'react';
import { TbPlayerStopFilled } from 'react-icons/tb';
import { SendOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { Button } from 'antd';
import { useAudioRecorder } from 'react-audio-voice-recorder';
import { convertSecondsToTimer } from '../../../helpers';
import VoiceNotePlayer from '../../Base/VoiceNotePlayer';
import { generateWaveformBars } from '../../Base/VoiceNotePlayer/helpers';
import useWaveformBarCount from '../../Base/VoiceNotePlayer/useWaveformBarCount';
import useLiveWaveform from './useLiveWaveform';
import { ReactComponent as TrashOutlinedIcon } from '../../../assets/icons/deleteIcon/trash-bin-red.svg';
import s from './AudioRecordBar.module.scss';
const AudioRecorderBar = ({ onSendAudioMessage, onClose }) => {
    const [voiceBlob, setVoiceBlob] = useState(null);
    const onSend = () => {
        if (voiceBlob) {
            const file = new File([voiceBlob], 'audio.mp3', { type: 'audio/mpeg' });
            onSendAudioMessage(file);
        }
    };
    const { startRecording, stopRecording, recordingBlob, isRecording, recordingTime, mediaRecorder } = useAudioRecorder();
    const liveBarsRef = useRef(null);
    const barCount = useWaveformBarCount(liveBarsRef);
    const liveBars = useLiveWaveform(mediaRecorder, isRecording, barCount);
    const placeholderBars = useMemo(() => generateWaveformBars('recording-placeholder', barCount), [barCount]);
    useEffect(() => {
        startRecording();
    }, []);
    useEffect(() => {
        if (!recordingBlob)
            return;
        setVoiceBlob(recordingBlob);
    }, [recordingBlob]);
    const previewUrl = useMemo(() => (voiceBlob ? URL.createObjectURL(voiceBlob) : ''), [voiceBlob]);
    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
            }
        };
    }, [previewUrl]);
    return (React.createElement("div", { className: s.container },
        React.createElement(Button, { icon: React.createElement(TrashOutlinedIcon, null), onClick: () => onClose(), className: classNames('voice-recorder_controlgeneric', s.deleteButton, {
                [s.show]: !isRecording && voiceBlob,
            }), shape: "circle", type: "primary", danger: true }),
        React.createElement("div", { className: s.recordingWrapper }, isRecording || !voiceBlob ? (React.createElement("div", { className: s.recording },
            React.createElement("span", { className: s.recordingDot }),
            React.createElement("span", { className: s.timer }, convertSecondsToTimer(recordingTime)),
            React.createElement("div", { className: s.liveBars, ref: liveBarsRef }, (liveBars || placeholderBars).map((height, i) => (React.createElement("div", { key: i, className: classNames(s.liveBar, { [s.pulsing]: !liveBars }), style: { height: `${Math.round(height * 22)}px` } })))))) : (React.createElement(VoiceNotePlayer, { src: previewUrl, seed: `preview-${voiceBlob.size}`, className: s.audio }))),
        isRecording || !voiceBlob ? (React.createElement(Button, { icon: React.createElement(TbPlayerStopFilled, null), onClick: stopRecording, className: s.recordButton, shape: "circle", type: "primary", disabled: !isRecording && !voiceBlob })) : (React.createElement(Button, { className: s.sendButton, onClick: onSend },
            React.createElement(SendOutlined, null)))));
};
export default AudioRecorderBar;
